// @flow strict
import { useStaticQuery, graphql } from 'gatsby';
import _ from 'lodash';

const useTagsList = () => {
  const { allMarkdownRemark } = useStaticQuery(
    graphql`
      query TagsListQuery {
        allMarkdownRemark(
          filter: {
            frontmatter: {
              template: { in: ["walking-post", "post"] }
              draft: { ne: true }
            }
          }
        ) {
          neighborhoodsGroup: group(field: frontmatter___neighborhoods) {
            fieldValue
            totalCount
          }
          landmarksGroup: group(field: frontmatter___landmarks) {
            fieldValue
            totalCount
          }
          tagsGroup: group(field: frontmatter___tags) {
            fieldValue
            totalCount
          }
          parksGroup: group(field: frontmatter___parks) {
            fieldValue
            totalCount
          }
        }
      }
    `
  );

  const aggregatedTags = [
    ...allMarkdownRemark.neighborhoodsGroup,
    ...allMarkdownRemark.landmarksGroup,
    ...allMarkdownRemark.tagsGroup,
    ...allMarkdownRemark.parksGroup,
  ];
  const uniqTags = _.uniqBy(aggregatedTags, 'fieldValue');
  const tags = _.sortBy(uniqTags, 'fieldValue');

  return tags;
};

export default useTagsList;
